// El snapshot pasó de objeto legacy a un arreglo plano (estado × distrito × mesa).
// Este adapter lo reagrupa para que los componentes consuman la forma de siempre.

const createEmptyStats = () => ({
    electronic_voted: 0,
    manual_voted: 0,
    ready: 0,
    ready_defaulting: 0,
    ready_disabled: 0,
    registered: 0,
    registered_defaulting: 0,
    registered_disabled: 0
});

export const adapterSnapshotData = (newData, election_id, election_name) => {

    const root = {
        _id: election_id,
        name: election_name,
        total_voters: 0,
        total_weighted: 0,
        voters: createEmptyStats(),
        weighted: createEmptyStats(),
        districts: {}
    };

    newData.forEach(item => {
        const {state, name, district_id, ballotbox_id} = item._id;
        const count = item.count;
        const weighted = item.weighted;

        // Un estado desconocido sumaría sobre undefined y dejaría todos los totales en NaN.
        if (!(state in root.voters)) {
            console.warn("adapterSnapshotData: estado desconocido en el snapshot, se ignora:", state);
            return;
        }

        // Totales globales
        root.voters[state] += count;
        root.weighted[state] += weighted;
        root.total_voters += count;
        root.total_weighted += weighted;

        // Distrito
        if (!root.districts[district_id]) {
            root.districts[district_id] = {
                // TurnoutTable lo usa como key de cada mesa; el formato nuevo solo lo trae en _id.
                district_id: district_id,
                name: name,
                factor: item.factor,
                voters: createEmptyStats(),
                weighted: createEmptyStats(),
                ballotboxes: {}
            };
        }

        const d = root.districts[district_id];
        d.voters[state] += count;
        d.weighted[state] += weighted;

        // Mesa
        if (!d.ballotboxes[ballotbox_id]) {
            d.ballotboxes[ballotbox_id] = {
                name: "mesa única",
                voters: createEmptyStats(),
                weighted: createEmptyStats()
            };
        }

        const b = d.ballotboxes[ballotbox_id];
        b.voters[state] += count;
        b.weighted[state] += weighted;
    });

    // El backend entrega los items en orden no determinista y TurnoutTable no ordena: sin esto
    // los distritos se barajan entre recargas. Numérico por si algún id no lleva cero adelante.
    const sorted_districts = {};
    Object.keys(root.districts)
        .sort((a, b) => a.localeCompare(b, undefined, {numeric: true}))
        .forEach(district_id => {
            sorted_districts[district_id] = root.districts[district_id];
        });
    root.districts = sorted_districts;

    return (root);
};
